





































































































import { initState } from '@/store/modules/dashboard/modules/dashboard-data-layout';
import topo, { State as topoState } from '@/store/modules/topology';
import AlarmContainers from '@/views/containers/alarm.vue';
import EndpointSurveyWindow from '@/views/containers/endpoint-survey-window.vue';
import InstancesSurveyWindow from '@/views/containers/instances-survey-window.vue';
import TraceContainers from '@/views/containers/trace.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation, State } from 'vuex-class';
import Radial from './radial.vue';
import TopoChart from './topo-chart.vue';
import ChartResponse from './topo-response.vue';
import TopoService from './topo-services.vue';
import TopoInstanceDependency from './topo-instance-dependency.vue';
import TopoDetectPoint from './topo-detect-point.vue';

@Component({
  components: {
    TopoChart, TopoService, ChartResponse, Radial, AlarmContainers,
    TraceContainers, InstancesSurveyWindow, EndpointSurveyWindow,
    TopoInstanceDependency, TopoDetectPoint,
  },
})
export default class TopoAside extends Vue {
  @State('rocketTopo') private stateTopo!: topoState;
  @State('rocketOption') private stateDashboardOption!: any;
  @Getter('intervalTime') private intervalTime: any;
  @Getter('durationTime') private durationTime: any;
  @Action('rocketTopo/GET_TOPO') private GET_TOPO: any;
  @Action('rocketTopo/CLEAR_TOPO') private CLEAR_TOPO: any;
  @Action('SELECT_SERVICE') private SELECT_SERVICE: any;
  @Mutation('rocketTopo/SET_MODE_STATUS') private SET_MODE_STATUS: any;
  @Action('rocketTopo/CLEAR_TOPO_INFO') private CLEAR_TOPO_INFO: any;
  @Mutation('SET_COMPS_TREE') private SET_COMPS_TREE: any;
  @Mutation('SET_EVENTS') private SET_EVENTS: any;
  @State('rocketDashboard') private rocketDashboard: any;

  private dialogTopoVisible = false;
  private drawerMainBodyHeight = '100%';
  private initState = initState;
  private radioStatus: boolean = false;
  private show: boolean = true;

  private get showServerInfo() {
    return this.stateTopo.currentNode.name && this.stateTopo.currentNode.isReal;
  }

  private resize() {
    this.drawerMainBodyHeight = `${document.body.clientHeight - 50}px`;
  }

  private created() {
    this.SET_EVENTS([]);
    this.SET_COMPS_TREE(this.initState.tree);
  }

  private mounted() {
    this.resize();
    window.addEventListener('resize', this.resize);
  }

  private getTopo() {
    this.GET_TOPO({duration: this.durationTime});
  }

  private beforeDestroy() {
    window.removeEventListener('resize', this.resize);
    this.CLEAR_TOPO_INFO();
    this.CLEAR_TOPO();
    this.$store.unregisterModule('rocketTopo');
  }

  get types() {
    const result: any = {};
    this.stateTopo.nodes.forEach((i: any) => {
      if (result[i.type]) {
        result[i.type] += 1;
      } else {
        result[i.type] = 1;
      }
    });
    return result;
  }

  @Watch('durationTime')
  private watchDurationTime() {
    this.getTopo();
  }

  private showRadial() {
    this.radioStatus = !this.radioStatus;
  }
}
